import { FC } from 'react'
import { Typography, Box, Alert } from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import DateAccordion from './DateAccordion'
import { ImportSummaryData, Surgery, DateGroupedSurgeries } from '../types'

interface ImportSummaryContentProps {
  importSummary: ImportSummaryData | null
  uploadError: string | null
}

const ImportSummaryContent: FC<ImportSummaryContentProps> = ({
  importSummary,
  uploadError,
}) => {
  const groupSurgeriesByDate = (surgeries: Surgery[]): DateGroupedSurgeries => {
    return surgeries.reduce<DateGroupedSurgeries>((acc, surgery) => {
      if (!acc[surgery.date]) {
        acc[surgery.date] = []
      }
      acc[surgery.date].push(surgery)
      return acc
    }, {})
  }

  if (uploadError) {
    return (
      <Alert severity="error" sx={{ marginTop: '20px' }}>
        {uploadError}
      </Alert>
    )
  }

  if (!importSummary) {
    return null
  }

  return (
    <Box>
      <Box className="success-message">
        <CheckCircleOutlineIcon color="success" />
        <Typography variant="h6">
          Successfully imported {importSummary.count} surgeries.
        </Typography>
      </Box>

      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        Preview of imported surgeries:
      </Typography>

      <Box className="surgery-container">
        {Object.entries(groupSurgeriesByDate(importSummary.surgeries)).map(
          ([date, surgeries]) => (
            <DateAccordion key={date} date={date} surgeries={surgeries} />
          )
        )}
      </Box>
    </Box>
  )
}

export default ImportSummaryContent
